export default __webpack_public_path__ + "static/vlad-325dd592c9a0371321fcaa954f58572f.png";